export const GET_DEVICE_CONTROL_COLUMNS_REQUEST = 'GET_DEVICE_CONTROL_COLUMNS_REQUEST';
export const GET_DEVICE_CONTROL_COLUMNS_SUCCESS = 'GET_DEVICE_CONTROL_COLUMNS_SUCCESS';
export const GET_DEVICE_CONTROL_COLUMNS_FAILURE = 'GET_DEVICE_CONTROL_COLUMNS_FAILURE';

export const GET_DEVICE_CONTROL_REQUEST = 'GET_DEVICE_CONTROL_REQUEST';
export const GET_INITIAL_DEVICE_CONTROL_SUCCESS = 'GET_INITIAL_DEVICE_CONTROL_SUCCESS';
export const GET_DEVICE_CONTROL_SUCCESS = 'GET_DEVICE_CONTROL_SUCCESS';
export const GET_DEVICE_CONTROL_FAILURE = 'GET_DEVICE_CONTROL_FAILURE';

export const SAVE_DEVICE_CONTROL_SEARCH_PARAMETERS = 'SAVE_DEVICE_CONTROL_SEARCH_PARAMETERS';

export const SELECT_DEVICE_CONTROL_SUCCESS = 'SELECT_DEVICE_CONTROL_SUCCESS';
export const SELECT_ALL_DEVICE_CONTROL_SUCCESS = 'SELECT_ALL_DEVICE_CONTROL_SUCCESS';
